import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AuthCallback = () => {
  const { processGoogleSession, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      // Extract session_id from URL fragment
      const hash = location.hash || window.location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        navigate('/login');
        return;
      }

      const result = await processGoogleSession(sessionId);

      if (result.success) {
        // Navigate based on user role
        if (result.data.role === 'tenant') {
          navigate('/tenant-portal', { state: { user: result.data }, replace: true });
        } else {
          navigate('/dashboard', { state: { user: result.data }, replace: true });
        }
      } else {
        navigate('/login', { state: { error: result.error }, replace: true });
      }
    };

    processSession();
  }, [location.hash, processGoogleSession, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-black border-t-transparent animate-spin mx-auto mb-4"></div>
        <p className="text-sm text-gray-600">Authenticating...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
